// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2JqLe","location":"Header_location__bICKG"};